import { RootState } from "../app/store";
import { createSlice } from "@reduxjs/toolkit";
import type { PayloadAction, SerializedError } from "@reduxjs/toolkit";

export interface AuthState {
  authenticated: boolean;
  token?: string;
  error?: SerializedError;
}

const initialState: AuthState = {
  authenticated: false,
  error: undefined,
};

export const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    updateToken: (state, action: PayloadAction<string>) => {
      state.authenticated = true;
      state.token = action.payload;
    },
    deleteToken: (state) => {
      state.authenticated = false;
      state.token = undefined;
    },
  },
});

export const selectAuthenticated = (state: RootState) =>
  state.auth.authenticated;
export const selectAuthError = (state: RootState) => state.auth.error;

export const { updateToken, deleteToken } = authSlice.actions;

export default authSlice.reducer;
